export { default } from './Box';
export type { Props } from './Box';



// WEBPACK FOOTER //
// ../kibble/components/Box/index.ts